<template>
  <div id="app_edit_design_tab">
    <b-row v-if="mounted">
      <b-col cols="6">

        <!-- First color -->
        <b-row style="margin-bottom: 1.714rem">
          <b-col cols="5">
            <div class="color-name-title">
              {{ $t('apps.primaryColor') }}
            </div>
            <div class="color-name-des">
              {{ $t('apps.importantTextsAndIcons') }}
            </div>
          </b-col>
          <b-col cols="7">
            <color-picker
              v-model="first_color"
              :color="first_color"
            />
          </b-col>
        </b-row>

        <!-- Second color -->
        <b-row style="margin-bottom: 1.714rem">
          <b-col cols="5">
            <div class="color-name-title">
              {{ $t('apps.secondaryColor') }}
            </div>
            <div class="color-name-des">
              {{ $t('apps.someButtonsAndIcons') }}
            </div>
          </b-col>
          <b-col cols="7">
            <color-picker
              v-model="second_color"
              :color="second_color"
            />
          </b-col>
        </b-row>

        <!-- Third color -->
        <b-row style="margin-bottom: 1.714rem">
          <b-col cols="5">
            <div class="color-name-title">
              {{ $t('apps.textColor') }}
            </div>
            <div class="color-name-des">
              {{ $t('apps.explanationsAndGeneralText') }}
            </div>
          </b-col>
          <b-col
            cols="2"
            style="border-right: 0.143rem solid #ddd;"
          >
            <color-picker
              v-model="third_color"
              :color="third_color"
            />
          </b-col>
          <b-col
            cols="5"
            style="padding-left: 1.143rem;"
          >
            <span style="line-height: 2.5rem;">{{ $t('apps.weRecommendToKeepItBlack') }}</span>
          </b-col>
        </b-row>
        <b-row style="margin-bottom: 1.714rem">
          <b-col cols="5">
            <div class="color-name-title">
              {{ $t('apps.criticalColor') }}
            </div>
            <div class="color-name-des">
              {{ $t('apps.validationErrorsSvgColor') }}
            </div>
          </b-col>
          <b-col cols="2">
            <color-picker
              v-model="critical_color"
              :color="critical_color"
            />
          </b-col>
        </b-row>
        <b-row style="margin-bottom: 1.714rem">
          <b-col
            cols="5"
            class="d-flex align-items-center"
          >
            <div class="color-name-title">
              {{ $t('apps.textDefaultColor') }}
            </div>
          </b-col>
          <b-col cols="2">
            <color-picker
              v-model="text_default"
              :color="text_default"
              :nullable="true"
            />
          </b-col>
        </b-row>

        <hr style="margin-bottom: 1.714rem">

        <h4 class="font-weight-bolder mb-2">
          {{ $t('apps.additionalColors') }}
        </h4>
        <!-- Pages background -->
        <b-row style="margin-bottom: 1.714rem">
          <b-col cols="5">
            <div class="color-name-title">
              {{ $t('apps.pagesBackground') }}
            </div>
            <div class="color-name-des">
              {{ $t('apps.colorOfTheEntireBackgroundOnSuchPagesLike') }}
            </div>
          </b-col>
          <b-col cols="7">
            <color-picker
              v-model="pages_bg"
              :color="pages_bg"
            />
          </b-col>
        </b-row>

        <!-- Components background -->
        <b-row style="margin-bottom: 1.714rem">
          <b-col cols="5">
            <div class="color-name-title">
              {{ $t('apps.componentsBackground') }}
            </div>
            <div class="color-name-des">
              {{ $t('apps.backgroundForElementsLikeSurveyListItemDateSelector') }}
            </div>
          </b-col>
          <b-col cols="2">
            <color-picker
              v-model="components_bg"
              :color="components_bg"
            />
          </b-col>
        </b-row>

        <!-- Survey list background -->
        <b-row style="margin-bottom: 1.714rem">
          <b-col
            cols="4"
            class="d-flex align-items-center"
          >
            <div class="color-name-title">
              {{ $t('apps.surveyListBackground') }}
            </div>
          </b-col>
          <b-col
            cols="1"
            class="d-flex align-items-start"
          >
            <div
              class="form-inline d-flex align-items-start mt-25"
              style="height: 2.857rem;"
            >
              <b-form-checkbox
                v-model="is_custom_surveys_list_bg"
                switch
                class="mr-1"
                :value="1"
                :unchecked-value="0"
              />
            </div>
          </b-col>
          <b-col
            v-if="is_custom_surveys_list_bg"
            cols="2"
          >
            <color-picker
              v-model="surveys_list_bg"
              :color="surveys_list_bg"
            />
          </b-col>
        </b-row>

        <!-- Palette -->
        <b-row style="margin-bottom: 1.714rem">
          <b-col
            cols="4"
            class="d-flex align-items-center"
          >
            <div class="color-name-title">
              <feather-icon
                :icon="palette === 'light' ? 'SunIcon' : 'MoonIcon'"
                size="16"
              />
              {{ $t('apps.lightPalette') }}
            </div>
          </b-col>
          <b-col cols="2">
            <b-form-checkbox
              v-model="palette"
              value="light"
              unchecked-value="dark"
              switch
            />
          </b-col>
        </b-row>

        <!-- Actions Design -->
        <b-row style="margin-bottom: 1.714rem">
          <b-col
            cols="4"
            class="d-flex align-items-center"
          >
            <div class="color-name-title">
              {{ $t('apps.actionsDesign') }}
            </div>
          </b-col>
          <b-col cols="8">
            <b-form-radio-group
              v-model="actions_bg"
              name="actions_design"
              class="mr-1"
            >
              <b-form-radio value="primary">
                {{ $t('apps.primary') }}
              </b-form-radio>
              <b-form-radio value="secondary">
                {{ $t('apps.secondary') }}
              </b-form-radio>
              <b-form-radio value="gradient">
                {{ $t('apps.gradient') }}
              </b-form-radio>
            </b-form-radio-group>
          </b-col>
        </b-row>

        <hr style="margin-bottom: 1.714rem">

        <b-row class="mb-1">
          <b-col
            class="py-1"
            cols="4"
          >
            <div class="color-name-title">
              {{ $t('apps.customLogo') }}
            </div>
          </b-col>
          <b-col cols="8">
            <div
              class="form-inline"
              style="height: 2.857rem;"
            >
              <b-form-checkbox
                v-model="header"
                switch
                class="mr-1"
                :value="1"
                :unchecked-value="0"
              />
            </div>
          </b-col>
          <b-col
            v-if="header"
            cols="9"
          >
            <div
              v-if="design_file != null"
              id="app-design-image"
            >
              <img
                :src="design_file"
                :alt="$t('apps.designFile')"
              >
            </div>
            <drag-upload-file
              style="width: 36.214rem;"
              :accept="'image/png'"
              @load-file="loadFile($event)"
            >
              {{ $t('apps.uploadFile') }}
            </drag-upload-file>
          </b-col>
        </b-row>

        <hr style="margin-bottom: 1.714rem">

        <b-row class="mb-1">
          <b-col
            class="py-1"
            cols="4"
          >
            <div class="color-name-title">
              {{ $t('apps.currencyIcon') }}
            </div>
            <div class="color-name-des">
              {{ $t('apps.shownInsteadOfTheCurrencyNameUnlessYouPick') }}
            </div>
          </b-col>
          <b-col cols="8">
            <div
              v-if="currencyIconPreview"
              class="currency-icon-preview"
            >
              <img
                :src="currencyIconPreview"
                :alt="$t('apps.currencyIcon')"
              >
            </div>
            <drag-upload-file
              style="width: 100%; max-width: 36.214rem;"
              :accept="'image/svg+xml,image/png'"
              @load-file="loadCurrencyIcon($event)"
            >
              {{ $t('apps.uploadFile') }}
            </drag-upload-file>
            <small
              v-if="currency_icon_error"
              class="text-danger d-block mt-50"
            >{{ currency_icon_error }}</small>
            <small
              v-if="upload_currency_icon_name"
              class="text-secondary d-block mt-50"
            >{{ $t('apps.selected', { value1: upload_currency_icon_name }) }}</small>
            <div>
              <b-button
                v-if="currencyIconPreview"
                variant="outline-danger"
                size="sm"
                class="mt-1"
                @click="removeCurrencyIcon()"
              >
                {{ $t('apps.removeIcon') }}
              </b-button>
            </div>
            <b-radio-group
              v-if="currencyIconPreview"
              v-model="currency_icon_display_mode"
              class="mt-1"
              stacked
            >
              <b-radio value="icon">
                {{ $t('apps.iconOnly') }}
              </b-radio>
              <b-radio value="icon_name">
                {{ $t('apps.iconCurrencyName') }}
              </b-radio>
            </b-radio-group>
            <div class="color-name-des mt-1">
              {{ $t('apps.optionalSvgOrPngUpTo1MbLeave') }}
            </div>
          </b-col>
        </b-row>

        <hr style="margin-bottom: 1.714rem">

        <b-row class="mb-1">
          <b-col
            class="py-1"
            cols="4"
          >
            <div class="color-name-title">
              {{ $t('apps.customFonts') }}
            </div>
            <div class="color-name-des">
              {{ $t('apps.appliesYourOwnTypefaceToSurveysAndOffers') }}
            </div>
          </b-col>
          <b-col cols="8">
            <div
              class="form-inline"
              style="height: 2.857rem;"
            >
              <b-form-checkbox
                v-model="custom_fonts_enabled"
                switch
                class="mr-1"
                :value="1"
                :unchecked-value="0"
              />
            </div>
          </b-col>
        </b-row>

        <b-row
          v-if="custom_fonts_enabled"
          class="mb-1"
        >
          <b-col cols="12">
            <div
              v-for="slot in fontSlots"
              :key="slot.key"
              class="mb-2"
            >
              <div class="color-name-title">
                {{ $t('apps.font', { value1: slot.label }) }}
              </div>
              <div class="color-name-des mb-50">
                {{ fontFileLabel(slot.key) }}
              </div>
              <drag-upload-file
                style="width: 100%; max-width: 36.214rem;"
                :accept="'.woff2,font/woff2'"
                @load-file="loadFont(slot.key, $event)"
              >
                {{ $t('apps.uploadFile') }}
              </drag-upload-file>
              <small
                v-if="font_errors[slot.key]"
                class="text-danger d-block mt-50"
              >{{ font_errors[slot.key] }}</small>
              <div>
                <b-button
                  v-if="hasFont(slot.key)"
                  variant="outline-danger"
                  size="sm"
                  class="mt-1"
                  @click="removeFont(slot.key)"
                >
                  {{ $t('apps.removeItem', { value1: slot.label.toLowerCase() }) }}
                </b-button>
              </div>
            </div>
            <div
              v-if="missingFontSlots.length > 0"
              class="text-danger"
            >
              {{ $t('apps.youNeedToUploadAll3FontStyles') }}
            </div>
            <div class="color-name-des">
              {{ $t('apps.woff2OnlyUpTo2MbEachFontsAppear') }}
            </div>
          </b-col>
        </b-row>

        <hr style="margin-bottom: 1.714rem">

        <b-row>
          <b-col
            class="py-1"
            cols="4"
          >
            <div class="color-name-title">
              {{ $t('apps.userIncome') }}
            </div>
          </b-col>
          <b-col cols="8">
            <div
              class="form-inline"
              style="height: 2.857rem;"
            >
              <b-form-checkbox
                v-model="stats"
                switch
                class="mr-1"
                :value="1"
                :unchecked-value="0"
              />
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            class="py-1"
            cols="4"
          >
            <div class="color-name-title">
              {{ $t('apps.showRewards') }}
            </div>
          </b-col>
          <b-col cols="8">
            <div
              class="form-inline"
              style="height: 2.857rem;"
            >
              <b-form-checkbox
                v-model="show_rewards"
                switch
                class="mr-1"
                :value="1"
                :unchecked-value="0"
              />
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            class="py-1"
            cols="4"
          >
            <div class="color-name-title">
              {{ $t('apps.showFilters') }}
            </div>
          </b-col>
          <b-col cols="8">
            <div
              class="form-inline"
              style="height: 2.857rem;"
            >
              <b-form-checkbox
                v-model="show_filters"
                switch
                class="mr-1"
                :value="1"
                :unchecked-value="0"
              />
            </div>
          </b-col>
        </b-row>

        <hr style="margin-bottom: 1.714rem">

        <b-row>
          <b-col
            class="py-1"
            cols="3"
          >
            <div class="color-name-title">
              {{ $t('apps.policyUrl') }}
            </div>
          </b-col>
          <b-col cols="9">
            <div
              class="w-full"
              style="height: 2.857rem;"
            >
              <b-input
                v-model="policy_url"
              />
            </div>
          </b-col>
        </b-row>

        <hr style="margin-bottom: 1.714rem">

        <b-row class="mb-2">
          <b-col>
            <b-button
              variant="primary"
              @click="changeBackToDefaultColor()"
            >
              {{ $t('apps.changeBackToDefault') }}
            </b-button>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="6">
        <div
          v-for="preview in designPreviews"
          :key="preview.url"
        >
          <label style="font-weight: 500; font-size: 1rem; line-height: 100%; color: #5E5873; margin-bottom: 1.143rem;">
            {{ preview.name }}
          </label>
          <div v-if="isIframeReady">
            <iframe
              ref="designIframe"
              style="border: 1px solid #DBE1E6; box-sizing: border-box; border-radius: 4px;"
              frameborder="0"
              :src="preview.url"
              width="400px"
              height="700px"
            />
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import i18n from '@/libs/i18n'

import DragUploadFile from '@ps_main/custom-components/DragUploadFile.vue'
import ColorPicker from '@ps_main/custom-components/ColorPickerInput.vue'

export default {
  components: {
    DragUploadFile,
    ColorPicker,
  },
  props: ['value'],
  data() {
    return {
      first_color: '#164ed0',
      second_color: '#f13870',
      third_color: '#000000',
      critical_color: '#F13870',
      text_default: null,
      upload_design_file: null,
      design_file: null,
      pages_bg: '#ffffff',
      components_bg: '#ffffff',
      surveys_list_bg: null,
      is_custom_surveys_list_bg: 0,
      show_rewards: 0,
      show_filters: 0,
      isIframeReady: false,
      root: null,
      mounted: false,
      header: 0,
      stats: 0,
      palette: 'light',
      policy_url: null,
      actions_bg: 'gradient',
      upload_currency_icon: null,
      upload_currency_icon_name: null,
      upload_currency_icon_preview: null,
      remove_currency_icon: 0,
      currency_icon_display_mode: 'icon',
      currency_icon_error: null,
      custom_fonts_enabled: 0,
      upload_font_medium: null,
      upload_font_semibold: null,
      upload_font_bold: null,
      upload_font_medium_name: null,
      upload_font_semibold_name: null,
      upload_font_bold_name: null,
      remove_font_medium: 0,
      remove_font_semibold: 0,
      remove_font_bold: 0,
      font_errors: {
        medium: null,
        semibold: null,
        bold: null,
      },
    }
  },
  computed: {
    validateForm() {
      return true
    },
    watchParentValue() {
      return [
        this.value.first_color,
        this.value.second_color,
        this.value.third_color,
        this.value.design_file,
        this.value.currency_name,
        this.value.currency_exchange_rate,
        this.value.critical_color,
        this.value.actions_bg,
        this.value.design_config,
      ]
    },
    storedCurrencyIconUrl() {
      if (this.remove_currency_icon) {
        return null
      }

      return this.value.design_config?.currency_icon?.url ?? null
    },
    currencyIconPreview() {
      return this.upload_currency_icon_preview ?? this.storedCurrencyIconUrl
    },
    fontSlots() {
      return [
        { key: 'medium', label: i18n.t('apps.medium') },
        { key: 'semibold', label: i18n.t('apps.semibold') },
        { key: 'bold', label: i18n.t('apps.bold') },
      ]
    },
    missingFontSlots() {
      if (!this.custom_fonts_enabled) {
        return []
      }

      return this.fontSlots.filter(slot => !this.hasFont(slot.key)).map(slot => slot.key)
    },
    lastUrlPathRoute() {
      return this.$route.params.appHash
    },
    iframeUrlQuery() {
      return `test=1&col1=${encodeURIComponent(this.first_color)
      }&app=${this.lastUrlPathRoute
      }&header=${encodeURIComponent(this.header)
      }&stats=${encodeURIComponent(this.stats)
      }&col2=${encodeURIComponent(this.second_color)
      }&col3=${encodeURIComponent(this.third_color)
      }&cr_col=${encodeURIComponent(this.critical_color)
      }&txt_def_col=${encodeURIComponent(this.text_default === null ? '' : this.text_default)
      }&img=${encodeURIComponent(
        this.design_file === null ? '' : this.design_file,
      )
      }&cur_name=${encodeURIComponent(this.value.currency_name === null ? '' : this.value.currency_name)
      }&mv_dec=${encodeURIComponent(this.value.move_decimals === null ? '' : this.value.move_decimals)
      }&cur_ex_rate=${encodeURIComponent(this.value.currency_exchange_rate === null ? '' : this.value.currency_exchange_rate)
      }&pages_bg=${encodeURIComponent(this.pages_bg === null ? '' : this.pages_bg)
      }&comp_bg=${encodeURIComponent(this.components_bg === null ? '' : this.components_bg)
      }&srv_list_bg=${encodeURIComponent(this.surveys_list_bg === null ? '' : this.surveys_list_bg)
      }&show_rewards=${encodeURIComponent(this.show_rewards === null ? '' : this.show_rewards)
      }&show_filters=${encodeURIComponent(this.show_filters === null ? '' : this.show_filters)
      }&palette=${encodeURIComponent(this.palette === null ? '' : this.palette)
      }&pol_url=${encodeURIComponent(this.policy_url === null ? '' : this.policy_url)
      }&actions_bg=${encodeURIComponent(this.actions_bg)
      }&cur_icon=${encodeURIComponent(this.value.design_config?.currency_icon?.url ?? '')
      }&cur_icon_mode=${encodeURIComponent(this.value.design_config?.currency_icon?.display_mode ?? '')
      }&font_med=${encodeURIComponent(this.savedFontUrl('medium'))
      }&font_semi=${encodeURIComponent(this.savedFontUrl('semibold'))
      }&font_bold=${encodeURIComponent(this.savedFontUrl('bold'))
      }&font_on=${encodeURIComponent(this.value.design_config?.fonts?.enabled ? 1 : 0)
      }`
    },
    iframeBaseUrl() {
      const SURVEY_BASE_URL = process.env.VUE_APP_SURVEY_BASE_URL

      return `${SURVEY_BASE_URL}/design-preview`
    },
    iframeUrlSurveys() {
      return `${this.iframeBaseUrl}/surveys?${this.iframeUrlQuery}`
    },
    iframeUrlQualified() {
      return `${this.iframeBaseUrl}/qualify?${this.iframeUrlQuery}`
    },
    iframeUrlControls() {
      return `${this.iframeBaseUrl}/controls?${this.iframeUrlQuery}`
    },
    iframeUrlOffers() {
      return `${this.iframeBaseUrl}/offers?${this.iframeUrlQuery}`
    },
    iframeUrlOffer() {
      return `${this.iframeBaseUrl}/offer?${this.iframeUrlQuery}`
    },
    designPreviews() {
      const previews = [
        {
          name: i18n.t('apps.surveysListPreview'),
          url: this.iframeUrlSurveys,
        },
        {
          name: i18n.t('apps.surveyQualifiedPreview'),
          url: this.iframeUrlQualified,
        },
        {
          name: i18n.t('apps.inputControlsPreview'),
          url: this.iframeUrlControls,
        },
      ]
      if (this.value.is_games_offers_enabled) {
        previews.push(
          {
            name: i18n.t('apps.offersListPreview'),
            url: this.iframeUrlOffers,
          },
          {
            name: i18n.t('apps.offerDetailsPreview'),
            url: this.iframeUrlOffer,
          },
        )
      }
      return previews
    },
  },
  watch: {
    iframeUrlQuery: {
      immediate: true,
      handler(newVal) {
        this.$emit('iFrameURLQueryChanged', newVal)
      },
    },
    first_color() {
      this.syncToParent()
    },
    second_color() {
      this.syncToParent()
    },
    third_color() {
      this.syncToParent()
    },
    design_file() {
      this.syncToParent()
    },
    watchParentValue() {
      this.init_data()
    },
    header() {
      this.syncToParent()
    },
    stats() {
      this.syncToParent()
    },
    critical_color() {
      this.syncToParent()
    },
    pages_bg() {
      this.syncToParent()
    },
    components_bg() {
      this.syncToParent()
    },
    surveys_list_bg() {
      this.syncToParent()
    },
    show_rewards() {
      this.syncToParent()
    },
    show_filters() {
      this.syncToParent()
    },
    palette() {
      this.syncToParent()
    },
    text_default() {
      this.syncToParent()
    },
    policy_url() {
      this.syncToParent()
    },
    actions_bg() {
      this.syncToParent()
    },
    currency_icon_display_mode() {
      this.syncToParent()
    },
    custom_fonts_enabled(value) {
      // Rejections are cleared here rather than in init_data(), which re-runs whenever a
      // watched parent value changes and would wipe the error the save is blocking on.
      // Switching the feature off is the point at which a pending rejection stops
      // mattering, and it is also the only way a save can succeed while one exists.
      if (!value) {
        this.fontSlots.forEach(slot => this.$set(this.font_errors, slot.key, null))
      }

      this.syncToParent()
    },
    is_custom_surveys_list_bg(val) {
      if (!val) {
        this.surveys_list_bg = null
      }
    },
  },
  mounted() {
    this.init_data()
    this.isIframeReady = true
    this.mounted = true
  },
  beforeDestroy() {
    this.releaseCurrencyIconPreview()
  },
  methods: {
    changeBackToDefaultColor() {
      this.first_color = '#164ed0'
      this.second_color = '#f13870'
      this.third_color = '#000000'
      this.critical_color = '#F13870'
      this.text_default = null
      this.design_file = null
      this.upload_design_file = null
      this.pages_bg = '#ffffff'
      this.components_bg = '#ffffff'
      this.surveys_list_bg = null
      this.is_custom_surveys_list_bg = 0
      this.show_rewards = 0
      this.show_filters = 0
      this.palette = 'light'
      this.stats = 0
      this.header = 0
      this.policy_url = null
      this.actions_bg = 'gradient'
    },
    loadCurrencyIcon([file]) {
      if (!file) {
        return
      }

      const name = file.name.toLowerCase()

      if (!name.endsWith('.svg') && !name.endsWith('.png')) {
        this.currency_icon_error = i18n.t('apps.currencyIconMustBeAnSvgOrPngFile')
        return
      }

      if (file.size > 1024 * 1024) {
        this.currency_icon_error = i18n.t('apps.currencyIconMustBe1MbOrSmaller')
        return
      }

      this.currency_icon_error = null
      this.releaseCurrencyIconPreview()
      this.upload_currency_icon = file
      this.upload_currency_icon_name = file.name
      this.upload_currency_icon_preview = URL.createObjectURL(file)
      this.remove_currency_icon = 0
      this.syncToParent()
    },
    removeCurrencyIcon() {
      this.releaseCurrencyIconPreview()
      this.upload_currency_icon = null
      this.upload_currency_icon_name = null
      this.currency_icon_error = null
      this.remove_currency_icon = 1
      this.currency_icon_display_mode = 'icon'
      this.syncToParent()
    },
    releaseCurrencyIconPreview() {
      if (this.upload_currency_icon_preview) {
        URL.revokeObjectURL(this.upload_currency_icon_preview)
        this.upload_currency_icon_preview = null
      }
    },
    storedFontUrl(slot) {
      if (this[`remove_font_${slot}`]) {
        return null
      }

      return this.value.design_config?.fonts?.[slot]?.url ?? null
    },
    hasFont(slot) {
      return !!(this[`upload_font_${slot}`] || this.storedFontUrl(slot))
    },
    fontFileLabel(slot) {
      const pending = this[`upload_font_${slot}_name`]

      if (pending) {
        return i18n.t('apps.selected', { value1: pending })
      }

      return this.storedFontUrl(slot) ? i18n.t('apps.uploaded') : i18n.t('apps.notUploaded')
    },
    savedFontUrl(slot) {
      if (!this.value.design_config?.fonts?.enabled) {
        return ''
      }

      return this.value.design_config?.fonts?.[slot]?.url ?? ''
    },
    loadFont(slot, [file]) {
      if (!file) {
        return
      }

      if (!file.name.toLowerCase().endsWith('.woff2')) {
        this.$set(this.font_errors, slot, i18n.t('apps.fontsMustBeWoff2Files'))
        return
      }

      if (file.size > 2 * 1024 * 1024) {
        this.$set(this.font_errors, slot, i18n.t('apps.fontFilesMustBe2MbOrSmaller'))
        return
      }

      this.$set(this.font_errors, slot, null)
      this[`upload_font_${slot}`] = file
      this[`upload_font_${slot}_name`] = file.name
      this[`remove_font_${slot}`] = 0
      this.syncToParent()
    },
    removeFont(slot) {
      this[`upload_font_${slot}`] = null
      this[`upload_font_${slot}_name`] = null
      this[`remove_font_${slot}`] = 1
      this.$set(this.font_errors, slot, null)
      this.syncToParent()
    },
    validateCustomFonts() {
      // Nothing about fonts can block the save while the feature is off. The upload
      // fields are hidden then, so a leftover error would refuse the save with no
      // visible reason.
      if (!this.custom_fonts_enabled) {
        return true
      }

      // A rejected replacement leaves the previous file in place, so the slot still
      // counts as filled. Without this the save would go through while the rejection is
      // still on screen, which reads as though the new file was accepted.
      if (this.fontSlots.some(slot => this.font_errors[slot.key])) {
        return false
      }

      return this.missingFontSlots.length === 0
    },
    loadFile([uploadDesignFile]) {
      if (uploadDesignFile) {
        this.upload_design_file = uploadDesignFile
        this.design_file = URL.createObjectURL(uploadDesignFile)
      }
    },
    reset_data() {
      this.$emit('reset', [
        'first_color',
        'second_color',
        'third_color',
        'critical_color',
        'design_file',
      ])
    },
    init_data() {
      if (
        this.value.first_color !== null
          && this.value.second_color !== null
          && this.value.third_color !== null
      ) {
        this.first_color = `#${this.value.first_color}`
        this.second_color = `#${this.value.second_color}`
        this.third_color = `#${this.value.third_color}`
      }

      this.design_file = this.value.design_file
      if (typeof this.value.upload_design_file === 'object') {
        this.upload_design_file = this.value.upload_design_file
      } else {
        this.upload_design_file = null
      }
      this.header = this.value.header
      this.stats = this.value.stats
      this.critical_color = `#${this.value.critical_color}`
      this.text_default = this.value.text_default ? `#${this.value.text_default}` : null
      this.pages_bg = this.value.pages_bg ? `#${this.value.pages_bg}` : '#ffffff'
      this.components_bg = this.value.components_bg ? `#${this.value.components_bg}` : '#ffffff'
      this.surveys_list_bg = this.value.surveys_list_bg ? `#${this.value.surveys_list_bg}` : null
      this.show_rewards = this.value.show_rewards
      this.show_filters = this.value.show_filters
      this.palette = this.value.palette ?? 'light'
      this.policy_url = this.value.policy_url
      this.actions_bg = this.value.actions_bg ?? 'gradient'
      this.upload_currency_icon = typeof this.value.upload_currency_icon === 'object'
        ? this.value.upload_currency_icon
        : null
      this.upload_currency_icon_name = this.upload_currency_icon
        ? this.value.upload_currency_icon_name ?? null
        : null
      if (!this.upload_currency_icon) {
        this.releaseCurrencyIconPreview()
      }
      this.remove_currency_icon = this.value.remove_currency_icon ?? 0
      this.currency_icon_display_mode = this.value.currency_icon_display_mode
        ?? this.value.design_config?.currency_icon?.display_mode
        ?? 'icon'
      // currency_icon_error is not cleared here: this re-runs on any parent change.
      this.custom_fonts_enabled = this.value.custom_fonts_enabled
        ?? (this.value.design_config?.fonts?.enabled ? 1 : 0)
      this.fontSlots.forEach(slot => {
        this[`upload_font_${slot.key}`] = typeof this.value[`upload_font_${slot.key}`] === 'object'
          ? this.value[`upload_font_${slot.key}`]
          : null
        this[`upload_font_${slot.key}_name`] = this[`upload_font_${slot.key}`]
          ? this.value[`upload_font_${slot.key}_name`] ?? null
          : null
        this[`remove_font_${slot.key}`] = this.value[`remove_font_${slot.key}`] ?? 0
      })

      if (!this.mounted) {
        this.is_custom_surveys_list_bg = +(this.value.surveys_list_bg !== null)
      }
    },
    syncToParent() {
      if (this.mounted) {
        const appData = this.value
        appData.first_color = this.first_color.substring(1)
        appData.second_color = this.second_color.substring(1)
        appData.third_color = this.third_color.substring(1)
        appData.critical_color = this.critical_color.substring(1)
        appData.text_default = this.text_default ? this.text_default.substring(1) : null
        appData.design_file = this.design_file
        appData.upload_design_file = this.upload_design_file
        appData.header = this.header
        appData.stats = this.stats
        appData.pages_bg = this.pages_bg?.substring(1) ?? null
        appData.components_bg = this.components_bg?.substring(1) ?? null
        appData.surveys_list_bg = this.surveys_list_bg?.substring(1) ?? null
        appData.show_rewards = this.show_rewards
        appData.show_filters = this.show_filters
        appData.palette = this.palette
        appData.policy_url = this.policy_url
        appData.actions_bg = this.actions_bg
        appData.upload_currency_icon = this.upload_currency_icon
        appData.upload_currency_icon_name = this.upload_currency_icon_name
        appData.remove_currency_icon = this.remove_currency_icon
        appData.currency_icon_display_mode = this.currency_icon_display_mode
        appData.custom_fonts_enabled = this.custom_fonts_enabled
        this.fontSlots.forEach(slot => {
          appData[`upload_font_${slot.key}`] = this[`upload_font_${slot.key}`]
          appData[`upload_font_${slot.key}_name`] = this[`upload_font_${slot.key}_name`]
          appData[`remove_font_${slot.key}`] = this[`remove_font_${slot.key}`]
        })
        this.$emit('input', appData)
      }
    },
  },
}
</script>

<style scoped>
.con-input-upload {
  height: 2.5rem;
  margin: 0;
}

.con-img-upload {
  padding: 0;
}

#app-design-image {
  margin-bottom: 1rem;
  position: relative;
  border: 1px solid #d9e1e6;
  text-align: center;
}

#app-design-image img {
  max-width: 12rem;
  max-height: 12rem;
  margin: auto;
}

.currency-icon-preview {
  margin-bottom: 1rem;
  padding: 0.5rem;
  border: 1px solid #d9e1e6;
  text-align: center;
}

.currency-icon-preview img {
  max-width: 4rem;
  max-height: 4rem;
}

#app_edit_design_tab .vc-chrome-toggle-btn {
  display: none !important;
}

#app_edit_design_tab .vc-chrome-fields {
  width: 100%;
}

.color-name-title {
  font-style: normal;
  font-weight: 500;
  font-size: 1rem;
  line-height: 100%;
  color: #5E5873;
  margin-bottom: 0.571rem;
}

.color-name-des {
  font-style: normal;
  font-weight: 500;
  font-size: 0.857rem;
  line-height: 100%;
  color: #5E5873;
}
</style>
<style>
.color-picker > span > span {
  border-radius: 0.286rem 0 0 0.286rem;
}
</style>
